<template lang="html">
  <b-row>
    <b-col>
      <p class="small mb-1">
        Soundslides.com and Soundslides.org are produced by Joe Weiss @
        <a href="http://tungite.com">Tungite Labs</a>. © 2018-2022
      </p>
      <p class="small">
        <router-link :to="{ name: 'terms' }">Terms</router-link> |
        <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link> |
        <router-link :to="{ name: 'about' }">About</router-link>
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {};
</script>

<style lang="css" scoped></style>
